// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"layout_noScrolling__JniEX","main":"layout_main__SEIwM","head":"layout_head__JOAC7","fadein":"layout_fadein__f_6LH"};